var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99414 6C5.99414 4.89543 6.88957 4 7.99414 4H8.00614C9.11071 4 10.0061 4.89543 10.0061 6C10.0061 7.10457 9.11071 8 8.00614 8H7.99414C6.88957 8 5.99414 7.10457 5.99414 6Z",
    fill: "#414143"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9941 6C13.9941 4.89543 14.8896 4 15.9941 4H16.0061C17.1107 4 18.0061 4.89543 18.0061 6C18.0061 7.10457 17.1107 8 16.0061 8H15.9941C14.8896 8 13.9941 7.10457 13.9941 6Z",
    fill: "#414143"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99414 12C5.99414 10.8954 6.88957 10 7.99414 10H8.00614C9.11071 10 10.0061 10.8954 10.0061 12C10.0061 13.1046 9.11071 14 8.00614 14H7.99414C6.88957 14 5.99414 13.1046 5.99414 12Z",
    fill: "#414143"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9941 12C13.9941 10.8954 14.8896 10 15.9941 10H16.0061C17.1107 10 18.0061 10.8954 18.0061 12C18.0061 13.1046 17.1107 14 16.0061 14H15.9941C14.8896 14 13.9941 13.1046 13.9941 12Z",
    fill: "#414143"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99414 18C5.99414 16.8954 6.88957 16 7.99414 16H8.00614C9.11071 16 10.0061 16.8954 10.0061 18C10.0061 19.1046 9.11071 20 8.00614 20H7.99414C6.88957 20 5.99414 19.1046 5.99414 18Z",
    fill: "#414143"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9941 18C13.9941 16.8954 14.8896 16 15.9941 16H16.0061C17.1107 16 18.0061 16.8954 18.0061 18C18.0061 19.1046 17.1107 20 16.0061 20H15.9941C14.8896 20 13.9941 19.1046 13.9941 18Z",
    fill: "#414143"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragIcon);
export default __webpack_public_path__ + "static/media/drag-icon.e554a4c87bb037b72f6f7775813f0538.svg";
export { ForwardRef as ReactComponent };